module.exports = __webpack_public_path__ + "static/media/iccon-img-layers.339dde58.svg";